import { Injectable } from '@angular/core';

@Injectable()
export class AppMisc {
    handleHttpError(e: Error, queryStr?: string) {
        queryStr && console.error(queryStr);
        throw e;
    }
}
